export function languageToFlagCode (language) {
  const languageMap = {
    english: 'gb',
    french: 'fr',
    italian: 'it',
    spanish: 'es',
    german: 'de',
    japanese: 'jp',
    korean: 'kr',
    chinese: 'cn',
    arabic: 'sa',
    russian: 'ru'
  }
  return languageMap[language.toLowerCase()] || 'unknown' // Default to 'unknown' if not found
}
